import StoredLayout from '../../layouts/StoredLayout'
import Typography from './Typography'
export default StoredLayout(Typography)
